import type { Product } from '@shopgnd/shared';
import { islandListingUrlParishSlug } from '@shopgnd/shared';

export type ProductPathInput = Pick<Product, 'slug' | 'id' | 'parish'>;

/** Canonical product URL (/grenada/carriacou/product/{slug} on dependencies). */
export function productPath(product: ProductPathInput): string {
  const segment = product.slug ?? product.id;
  const island = islandListingUrlParishSlug(product.parish);
  return island
    ? `/grenada/${island}/product/${encodeURIComponent(segment)}`
    : `/grenada/product/${encodeURIComponent(segment)}`;
}
